import React, { useState } from "react";
import { Image } from "react-bootstrap";

import { LanguageConfig } from "config/CustomEnums";
import AdditionalQuestionPrompt from "./AdditionalQuestionPrompt";

import DeleteIcon from 'assets/images/deleteIcon.png';
import CustomerEdit from 'assets/images/customer_edit.svg';

import "./AdditionalQuestionBar.scss"

const AdditionalQuestionBar = ({
  data,
  onRemove = () => { },
  onEdit = () => { },
}) => {
  const title = data?.translations?.[LanguageConfig.english]?.fieldName 
  const [showEditPrompt, setShowEditPrompt] = useState(false)
  return (<>
    <div className="text-bar-with-buttons ">
      <div className={`create-section-label`} >
        {title}
      </div>
      <div>
        <button
          className="delete-condition-group-button"
          type="button"
          onClick={() => {
            setShowEditPrompt(true)
          }}
        >
          <Image src={CustomerEdit} className="content-delete-button" />
        </button>
        <button
          className="delete-condition-group-button"
          type="button"
          onClick={onRemove}
        >
          <Image src={DeleteIcon} className="content-delete-button" />
        </button>
      </div>
      </div>
    <AdditionalQuestionPrompt
      defaultValue={data}
      show={showEditPrompt}
      setShow={setShowEditPrompt}
      onComfirm={onEdit}
    />
  </>)
}

export default AdditionalQuestionBar;